document.addEventListener('DOMContentLoaded', () => {
  const scrollToTopButton = document.getElementById('back-top');
  const viewportHeight = window.innerHeight;
  const triggerPoint = viewportHeight * 2.5;

  if (!scrollToTopButton) {
    return;
  }

  const scrollFunc = () => {
    const y = window.pageYOffset;

    if (y > triggerPoint) {
      scrollToTopButton.className =
        'acg-btn acg-btn--icon-text acg-btn--secondary acg-btn--back-to-top show';
    } else {
      scrollToTopButton.className =
        'acg-btn acg-btn--icon-text acg-btn--secondary acg-btn--back-to-top hide';
    }
  };

  window.addEventListener('scroll', scrollFunc);

  const scrollToTop = () => {
    const offset =
      document.documentElement.scrollTop || document.body.scrollTop;

    if (offset > 0) {
      window.requestAnimationFrame(scrollToTop);
      window.scrollTo(0, offset - offset / 10);
    }
  };

  scrollToTopButton.onclick = function(e) {
    e.preventDefault();
    scrollToTop();
  };
});
